import React from "react";
import Radio from "@mui/material/Radio";
import {
  FormSection,
  SectionTitle,
  ShippingOption,
  ShippingOptionBody,
  ShippingOptionTitle,
  ShippingOptionDescription,
  ShippingOptionPrice,
} from "styles/pages/dtf-transfers/checkout";

const SHIPPING_OPTIONS = [
  {
    id: "standard",
    title: "Standard Shipping",
    description: "Estimated 5-7 business days",
    price: 25,
  },
  {
    id: "express",
    title: "Express Shipping",
    description: "Estimated 1-2 business days",
    price: 50,
  },
];

const ShippingStep = ({ selectedShipping, onChange, currency = "CAD" }) => {
  return (
    <FormSection>
      <SectionTitle>Shipping method</SectionTitle>

      {SHIPPING_OPTIONS.map((option) => {
        const selected = selectedShipping === option.id;

        return (
          <ShippingOption
            key={option.id}
            $selected={selected}
            style={{ marginBottom: "12px" }}
          >
            <Radio
              checked={selected}
              value={option.id}
              onChange={() => onChange(option.id)}
              size="small"
              sx={{
                padding: 0,
                color: "#9ca3af",
                "&.Mui-checked": { color: "#1594db" },
              }}
            />
            <ShippingOptionBody>
              <ShippingOptionTitle>{option.title}</ShippingOptionTitle>
              <ShippingOptionDescription>
                {option.description}
              </ShippingOptionDescription>
            </ShippingOptionBody>
            <ShippingOptionPrice>
              {currency} ${option.price.toFixed(2)}
            </ShippingOptionPrice>
          </ShippingOption>
        );
      })}
    </FormSection>
  );
};

export { SHIPPING_OPTIONS };
export default ShippingStep;
